module.exports = __webpack_public_path__ + "assets/img/36_1448_big.af09db14.jpg";